import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Table/table';
export const ExpandableRowContent = (_a) => {
    var { children = null } = _a, props = __rest(_a, ["children"]);
    return (React.createElement("div", Object.assign({}, props, { className: css(styles.tableExpandableRowContent) }), children));
};
ExpandableRowContent.displayName = 'ExpandableRowContent';
//# sourceMappingURL=ExpandableRowContent.js.map